import { render, staticRenderFns } from "./RegularImage.vue?vue&type=template&id=3897dad9&"
import script from "./RegularImage.vue?vue&type=script&lang=js&"
export * from "./RegularImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports